module.exports = __webpack_public_path__ + "img/stop1.a5042103.svg";